import {
  Icon,
  Portlet,
  PortletBody,
  PortletHeader,
  Text
} from '@energytoolbase/components'
import { faLockKeyhole } from '@fortawesome/pro-solid-svg-icons'
import React from 'react'
import styled from 'styled-components'

const AccessDeniedDiv = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h5 {
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }
`

export interface AccessDeniedProps {
  readonly pageTitle?: string
}

export function AccessDenied({ pageTitle }: AccessDeniedProps): JSX.Element {
  return (
    <Portlet>
      {pageTitle && <PortletHeader title={pageTitle} />}
      <PortletBody>
        <AccessDeniedDiv>
          <Icon name={faLockKeyhole} size={'30px'} />
          <h5>You don't have access to this page.</h5>
          <Text text="You don't have permissions to view this page. You can request access from your company administrator." />
        </AccessDeniedDiv>
      </PortletBody>
    </Portlet>
  )
}
